import { API_BASE_URL } from '../../env';
import { setupInterceptors } from '../interceptors';

import { createApiClient } from './base-client';

const clientV1 = createApiClient(API_BASE_URL);
setupInterceptors(clientV1);

export default clientV1;
